import { getDefaultList, onListChange } from '@theme/wishlist-core';

/**
 * ヘッダーのほしい物リスト件数バッジ。
 * マークアップは `snippets/swym-header-wishlist-yokomo.liquid`、
 * 保存先は `assets/swym-wishlist-core-yokomo.js`（`localStorage`）。
 *
 * ⚠️ 件数はサーバーから描けない（`localStorage` にしか無い）。テーマはヘッダーを
 * サーバー HTML で morph し直すことがあり、そのとき件数だけが HTML 側の 0 に
 * 巻き戻る（実測: `/collections/all` で読み込みの約 1 秒後、同じテキストノードの
 * `nodeValue` と `hidden` 属性が書き換えられる）。そのため状態はこのクラスが持ち、
 * 自分の subtree が書き換わったら描き直す。
 */
class SwymHeaderWishlistYokomo extends HTMLElement {
  #unsubscribe = null;
  /** @type {MutationObserver | null} */
  #observer = null;
  #count = 0;

  connectedCallback() {
    this.#unsubscribe = onListChange(({ detail }) => this.#apply(detail.list));
    getDefaultList().then((list) => this.#apply(list));

    this.#observer = new MutationObserver(() => this.#render());
    this.#observer.observe(this, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['hidden'],
    });
  }

  disconnectedCallback() {
    if (this.#unsubscribe) this.#unsubscribe();
    if (this.#observer) this.#observer.disconnect();
  }

  /** @param {{listcontents?: any[]}} list */
  #apply(list) {
    this.#count = list && Array.isArray(list.listcontents) ? list.listcontents.length : 0;
    this.#render();
  }

  /**
   * 現在の件数を DOM に反映する。morph でノードごと差し替わることがあるので毎回引き直す。
   * 既に一致しているときは何も書かない（`MutationObserver` との往復を止めるため）。
   */
  #render() {
    const el = this.querySelector('[data-ref="count"]');
    if (!el) return;

    const text = String(this.#count);
    const hidden = this.#count === 0;
    if (el.textContent === text && el.hidden === hidden) return;

    el.textContent = text;
    el.hidden = hidden;
  }
}

if (!customElements.get('swym-header-wishlist-yokomo')) {
  customElements.define('swym-header-wishlist-yokomo', SwymHeaderWishlistYokomo);
}
